import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["appearance", "children"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { PROPERTY_CARD_BADGE_APPEARANCES } from '../../constants';
import { StyledPropertyCardBadge } from './PropertyCardBadge.styles';

/**
 * Used by `PropertyCard` to highlight a particular piece of information
 * about a property. By default, the badge appears in the top-left corner of the card,
 * atop the property photo.
 *
 * @since 8.63.0
 */
export var PropertyCardBadge = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPropertyCardBadge, _extends({
    appearance: appearance,
    ref: forwardedRef
  }, rest), children);
});
PropertyCardBadge.displayName = 'PropertyCard.Badge';
PropertyCardBadge.propTypes = {
  /**
   * Determines the color of the badge.
   */
  appearance: PropTypes.oneOf(Object.values(PROPERTY_CARD_BADGE_APPEARANCES)),
  /**
   * Can include an `Icon`.
   */
  children: PropTypes.node
};
PropertyCardBadge.defaultProps = {
  appearance: 'default'
};